import type { DataTableMode } from '@odo/shared-ui';
import { useDmNotifications, useInfiniteDmNotifications } from '../../../hooks/useDmNotifications';
import type { DmNotificationFilters } from '../../../services/dmNotifications';

interface NotificationInboxQueryArgs {
    filters: DmNotificationFilters;
    mode: DataTableMode;
    page: number;
    limit: number;
    enabled: boolean;
}

// Both queries run unconditionally (rules of hooks); only the active mode's one is enabled.
export function useNotificationInboxQuery({
    filters,
    mode,
    page,
    limit,
    enabled
}: NotificationInboxQueryArgs) {
    const isInfinite = mode === 'infinite';
    const shared = { ...filters, limit };
    const paged = useDmNotifications({ ...shared, page, enabled: enabled && !isInfinite });
    const infinite = useInfiniteDmNotifications({ ...shared, enabled: enabled && isInfinite });
    const active = isInfinite ? infinite : paged;
    const query = {
        rows: active.rows,
        meta: active.meta,
        isLoading: active.isLoading || !enabled,
        // Rows from the previous filters while the new ones load; background refetches don't count.
        isShowingPrevious: active.isPlaceholderData,
        isError: active.isError,
        error: active.error,
        refresh: active.refresh
    };
    const loadMore = {
        onLoadMore: () => void infinite.fetchNextPage(),
        hasMore: infinite.hasNextPage,
        isLoadingMore: infinite.isFetchingNextPage
    };
    return { query, loadMore };
}
